var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './text-passage.styles';
/**
 * @slot default - The text passage content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksTextPassage extends BlocksElement {
    static { this.styles = styles; }
    /**
     * Add the light dom styles when this component is connected to a page
     */
    connectedCallback() {
        super.connectedCallback();
    }
    /**
     * First updated lifecycle hook
     * 1) Add class names to the wrapper cat-text-passage to allow the shadow DOM
     * to manipulate in React wrappers. Attributes get turned into props so we need
     * to append these class names to get the variants to style properly
     * IMPORTANT: variants are defined here so light DOM can manipulate the styles of
     * nested elements
     */
    firstUpdated() {
        if (this.size === 'sm') {
            this.classList.add('cat-text-passage--sm'); /* 1 */
        }
        if (this.size === 'xs') {
            this.classList.add('cat-text-passage--xs'); /* 1 */
        }
        if (this.inverted) {
            this.classList.add('cat-text-passage--inverted'); /* 1 */
        }
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-text-passage', {
            'cat-text-passage--sm': this.size === 'sm',
            'cat-text-passage--xs': this.size === 'xs',
            'cat-text-passage--inverted': this.inverted
        });
        return html `
      <div part="base" class="${componentClassName}">
        <slot part="part-default"></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: Boolean })
], BlocksTextPassage.prototype, "inverted", void 0);
__decorate([
    property({ type: String })
], BlocksTextPassage.prototype, "size", void 0);
if (customElements.get('cat-text-passage') === undefined) {
    customElements.define('cat-text-passage', BlocksTextPassage);
}
